import "twin.macro";

import { useEffect, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useSelector } from "react-redux";

import { BlockCard, ToggleButtons } from "@features/ui";
import { ControlledAutocompleteInput } from "@utils/forms";

type BrandView = "all" | "limited";

const UserFormBrands = () => {
  const { setValue, control, clearErrors } = useFormContext();
  const { hasMultipleBrands, brands: orgBrands } = useSelector(
    (state: any) => state.currentUser.organization
  );

  const brands = useWatch({ name: "brands" });
  const userId = useWatch({ name: "id" });
  const role = useWatch({ name: "role" });

  const [brandView, setBrandView] = useState<BrandView>(
    brands.length > 0 ? "limited" : "all"
  );

  const handleChange = (value: BrandView) => {
    setBrandView(value);
    clearErrors("brands");
    if (value === "all") {
      setValue("brands", [], { shouldDirty: true });
    } else {
      setValue("brands", orgBrands, { shouldDirty: true });
    }
  };

  useEffect(() => {
    setBrandView(brands.length > 0 ? "limited" : "all");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  if (!hasMultipleBrands || role === "super") return null;

  return (
    <BlockCard title="Brand Visibility">
      <ToggleButtons
        options={[
          {
            title: "All Brands",
            value: "all",
          },
          {
            title: "Limited Brands",
            value: "limited",
          },
        ]}
        onChange={handleChange}
        value={brandView}
        tabProps={{ className: "flex-1" }}
      />
      {brandView === "limited" && (
        <ControlledAutocompleteInput
          tw="mt-2"
          name="brands"
          control={control}
          options={orgBrands}
          multiple
          rules={{ required: "Brand is required" }}
          placeholder="Select Brands"
        />
      )}
    </BlockCard>
  );
};

export default UserFormBrands;
